export default "__VITE_ASSET__DzyPO9Yk__"